module.exports = __webpack_public_path__ + "static/media/JP_NS_EYELASHES03.8409ac59.jpg";